import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.UPDATE_EXPENSE_TRIGGER_REQUEST,
    SUCCESS: types.UPDATE_EXPENSE_TRIGGER_SUCCESS,
    FAILURE: types.UPDATE_EXPENSE_TRIGGER_FAILURE,
    CANCEL: types.UPDATE_EXPENSE_TRIGGER_CANCEL,
};

const basicReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: basicReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
